import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import priorityImg from '../../assets/about/priority.png';
import './Priority.scss';

const Priority = () => {
    return (
        <section className='priority-section emergency-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="priority-img">
                            <img src={priorityImg} alt="Emergência" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="priority-text">
                            <SectionTitle 
                                subTitle="NOSSA PRIORIDADE" 
                                title="Nossos clientes são a nossa prioridade"
                                description="Na nossa clínica, cada paciente recebe atenção personalizada e cuidados de qualidade. Nos dedicamos a oferecer tratamentos seguros, eficientes e confortáveis, garantindo que a experiência de cada cliente seja sempre nossa maior prioridade"
                            />

                            <div className="theme-btn">
                                <Link to='/'>Marcar Consulta</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Priority;